export const resolveVariable = (key, fallbackValue) => {
    const value = process.env[key];
    if (value) {
        return value;
    }
    else if (fallbackValue !== undefined) {
        return fallbackValue;
    }
    else {
        throw new Error(`Missing mandatory environment variable: ${key}`);
    }
};
//# sourceMappingURL=config.utils.js.map